import { render, staticRenderFns } from "./order_fh.vue?vue&type=template&id=fc0621b0&scoped=true"
import script from "./order_fh.vue?vue&type=script&lang=js"
export * from "./order_fh.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc0621b0",
  null
  
)

export default component.exports